/* DekalerSverige – "Designa egen dekal" (text, sociala medier, OnlyFans).
 * Prices and variants come straight from the Shopify product JSON (no API calls).
 * When adding to cart an SVG vector file of the design is generated in the
 * browser and attached to the order line as a file upload ("_Vektorfil (SVG)").
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-designer]');
  var T = window.Theme;
  if (!section || !T) return;
  var cfgEl = section.querySelector('[data-designer-config]');
  var root = section.querySelector('[data-designer-root]');
  if (!cfgEl || !root) return;

  var config = JSON.parse(cfgEl.textContent);
  var products = {
    text: config.products.text ? T.normalizeProduct(config.products.text) : null,
    social: config.products.social ? T.normalizeProduct(config.products.social) : null
  };

  var COLOR_HEX = {
    'Svart': '#000000', 'Vit': '#FFFFFF', 'Röd': '#E53E3E', 'Ljusblå': '#3B82F6', 'Rosa': '#EC4899',
    'Orange': '#F97316', 'Silver': '#9CA3AF', 'Guld': '#D4A843', 'Gul': '#F5D60A'
  };
  var COLOR_FILTER = {
    'Svart': 'none',
    'Vit': 'invert(1)',
    'Röd': 'invert(36%) sepia(89%) saturate(2096%) hue-rotate(338deg) brightness(94%) contrast(92%)',
    'Ljusblå': 'invert(45%) sepia(96%) saturate(1640%) hue-rotate(202deg) brightness(99%) contrast(94%)',
    'Rosa': 'invert(52%) sepia(92%) saturate(2615%) hue-rotate(295deg) brightness(95%) contrast(92%)',
    'Orange': 'invert(58%) sepia(86%) saturate(2300%) hue-rotate(346deg) brightness(99%) contrast(95%)',
    'Silver': 'invert(70%) sepia(7%) saturate(190%) hue-rotate(180deg) brightness(94%) contrast(89%)',
    'Guld': 'invert(70%) sepia(40%) saturate(700%) hue-rotate(2deg) brightness(95%) contrast(88%)',
    'Gul': 'invert(88%) sepia(72%) saturate(2200%) hue-rotate(355deg) brightness(102%) contrast(98%)'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Option detection ---------------- */
  function describe(product) {
    var info = { fontIdx: -1, colorIdx: -1, sizeIdx: -1 };
    if (!product) return info;
    product.optionNames.forEach(function (name, i) {
      var values = product.optionValues[i];
      var lower = String(name).toLowerCase();
      if (info.colorIdx === -1 && (lower.indexOf('färg') > -1 || lower === 'color' || lower === 'colour')) info.colorIdx = i;
      else if (info.fontIdx === -1 && values.some(function (v) { return /^\d+\.\d+$/.test(v); })) info.fontIdx = i;
      else if (info.sizeIdx === -1 && values.some(function (v) { return v.indexOf('cm') > -1; })) info.sizeIdx = i;
    });
    info.realColors = info.colorIdx > -1 ? product.optionValues[info.colorIdx] : [];
    // UI colours: Svart first + optional extra "Gul"
    var colors = info.realColors.slice();
    if (config.yellow && info.colorIdx > -1 && !colors.some(function (c) { return c.toLowerCase() === 'gul'; })) colors.push('Gul');
    colors.sort(function (a, b) {
      if (a.toLowerCase() === 'svart') return -1;
      if (b.toLowerCase() === 'svart') return 1;
      return 0;
    });
    info.uiColors = colors;
    return info;
  }

  var infos = { text: describe(products.text), social: describe(products.social) };

  function isFakeColor(info, value) {
    return value === 'Gul' && info.realColors.indexOf('Gul') === -1;
  }
  function realColor(info, value) {
    return isFakeColor(info, value) ? (info.realColors[0] || value) : value;
  }

  /* ---------------- Tabs + state ---------------- */
  var TABS = {
    text: { product: 'text', fonts: config.fonts.text, title: 'Designa egen dekal', label: 'Text', placeholder: 'Skriv din text här...', previewFallback: 'Din text här', empty: 'Skriv in en text först' },
    social: { product: 'social', fonts: config.fonts.social, title: 'Designa egen — Sociala medier', label: 'Användarnamn', placeholder: 'Ditt användarnamn', previewFallback: 'användarnamn', empty: 'Skriv in ett användarnamn först' },
    onlyfans: { product: 'text', fonts: config.fonts.onlyfans, title: 'Designa egen — OnlyFans', label: 'Text', placeholder: 'Din text', previewFallback: 'text', empty: 'Skriv in en text först' }
  };

  var state = {};
  function tabState(tab) {
    if (state[tab]) return state[tab];
    var def = TABS[tab];
    var product = products[def.product];
    var info = infos[def.product];
    var s = { text: '', mirrored: false, qty: 1 };
    if (tab === 'text') {
      s.font = info.fontIdx > -1 ? product.optionValues[info.fontIdx][0] : '1.0';
    } else {
      s.font = '1.0';
    }
    s.color = info.uiColors[0] || null;
    s.size = info.sizeIdx > -1 ? product.optionValues[info.sizeIdx][0] : null;
    s.platform = config.platforms[0];
    s.ofVariant = config.onlyfans[0];
    state[tab] = s;
    return s;
  }

  /** Builds the option array used to find the Shopify variant for a tab. */
  function selection(tab, overrides) {
    var def = TABS[tab];
    var product = products[def.product];
    var info = infos[def.product];
    var s = Object.assign({}, tabState(tab), overrides || {});
    return product.optionNames.map(function (_, i) {
      var first = product.optionValues[i][0];
      if (i === info.sizeIdx && s.size) return s.size;
      if (i === info.fontIdx) return tab === 'text' ? s.font : first;
      if (i === info.colorIdx) return tab === 'onlyfans' ? first : realColor(info, s.color);
      return first;
    });
  }

  function currentVariant(tab, overrides) {
    var product = products[TABS[tab].product];
    return T.findVariant(product, selection(tab, overrides));
  }

  /* ---------------- Rendering ---------------- */
  var activeTab = 'text';

  function fontInfo(tab) {
    var s = tabState(tab);
    var fonts = TABS[tab].fonts;
    return fonts[s.font] || fonts['1.0'];
  }

  function renderPanel(tab) {
    activeTab = tab;
    var def = TABS[tab];
    var product = products[def.product];
    var info = infos[def.product];
    var s = tabState(tab);
    var html = '';

    html += '<div class="designer__grid">';
    html += '<div class="designer__preview-col"><div class="designer__preview" data-preview>' + previewMarkup(tab) + '</div>';
    html += '<p class="designer__hint">Förhandsvisning. Den färdiga dekalen skärs ut i vinyl utan bakgrund.</p></div>';

    html += '<div class="designer__info">';
    html += '<h1 class="product__title">' + esc(def.title) + '</h1>';
    html += '<p class="product__price"><span data-price>—</span> <small class="muted">inkl. moms</small></p>';

    html += '<div class="field"><label class="field__label" for="DesignText">' + esc(def.label) + '</label>';
    html += '<input id="DesignText" class="input" type="text" maxlength="60" autocomplete="off" placeholder="' + esc(def.placeholder) + '" value="' + esc(s.text) + '" data-input-text></div>';

    if (tab === 'social') {
      html += '<fieldset class="field pills pills--grid3"><legend class="field__label">Plattform</legend>';
      config.platforms.forEach(function (p) {
        html += '<label class="pill pill--icon"><input type="radio" name="DesignPlatform" value="' + esc(p.id) + '"' + (s.platform.id === p.id ? ' checked' : '') + ' data-platform>' +
          '<span><img src="' + esc(p.icon) + '" alt="" width="20" height="20">' + esc(p.name) + '</span></label>';
      });
      html += '</fieldset>';
    }

    if (tab === 'onlyfans') {
      html += '<fieldset class="field"><legend class="field__label">Färg — <span class="muted" data-color-name>' + esc(s.ofVariant.name) + '</span></legend><div class="swatches">';
      config.onlyfans.forEach(function (v) {
        html += '<label class="swatch" title="' + esc(v.name) + '"><input type="radio" name="DesignOf" value="' + esc(v.id) + '"' + (s.ofVariant.id === v.id ? ' checked' : '') + ' data-of-variant>' +
          '<span style="background:' + esc(v.hex) + '"></span><span class="visually-hidden">' + esc(v.name) + '</span></label>';
      });
      html += '</div></fieldset>';
    }

    // Font
    var fontValues = tab === 'text' && info.fontIdx > -1 ? product.optionValues[info.fontIdx] : Object.keys(def.fonts);
    html += '<div class="field"><label class="field__label" for="DesignFont">Typsnitt</label><select id="DesignFont" class="select" data-font>';
    fontValues.forEach(function (v) {
      var f = def.fonts[v];
      html += '<option value="' + esc(v) + '"' + (s.font === v ? ' selected' : '') + '>' + esc(v.replace('.0', '')) + ' — ' + esc(f ? f.name : v) + '</option>';
    });
    html += '</select></div>';

    // Colour
    if (tab !== 'onlyfans' && info.colorIdx > -1) {
      html += '<fieldset class="field"><legend class="field__label">' + esc(product.optionNames[info.colorIdx]) + ' — <span class="muted" data-color-name>' + esc(s.color) + '</span></legend><div class="swatches">';
      info.uiColors.forEach(function (c) {
        html += '<label class="swatch" title="' + esc(c) + '"><input type="radio" name="DesignColor" value="' + esc(c) + '"' + (s.color === c ? ' checked' : '') + ' data-color>' +
          '<span style="background:' + esc(COLOR_HEX[c] || '#888') + '"></span><span class="visually-hidden">' + esc(c) + '</span></label>';
      });
      html += '</div></fieldset>';
    }

    // Size
    if (info.sizeIdx > -1) {
      var sizes = product.optionValues[info.sizeIdx];
      html += '<div class="field"><span class="field__label">Storlek i bredd (höjd sker automatiskt)</span>';
      if (sizes.length > 4) {
        html += '<select class="select" aria-label="Storlek" data-size>';
        sizes.forEach(function (v) { html += '<option value="' + esc(v) + '"' + (s.size === v ? ' selected' : '') + '>' + esc(v) + '</option>'; });
        html += '</select>';
      } else {
        html += '<div class="pills" role="radiogroup" aria-label="Storlek">';
        sizes.forEach(function (v) {
          html += '<label class="pill"><input type="radio" name="DesignSize" value="' + esc(v) + '"' + (s.size === v ? ' checked' : '') + ' data-size><span>' + esc(v) + '</span></label>';
        });
        html += '</div>';
      }
      html += '</div>';
    }

    if (config.mirror) {
      html += '<label class="check-card"><input type="checkbox" class="checkbox" data-mirror' + (s.mirrored ? ' checked' : '') + '>' +
        '<span><span class="check-card__title">Spegelvänd</span><span class="check-card__text">För applicering på insida av ruta</span></span></label>';
    }

    html += '<div class="stock"><span class="stock__dot"></span><span>Tillverkas vid beställning</span></div>';
    html += '<div class="buy-row"><div class="qty qty--lg">' +
      '<button type="button" class="qty__btn" aria-label="Minska antal" data-qty-step="-1">−</button>' +
      '<input type="number" class="qty__input" value="' + s.qty + '" min="1" max="99" aria-label="Antal" inputmode="numeric" data-qty>' +
      '<button type="button" class="qty__btn" aria-label="Öka antal" data-qty-step="1">+</button></div>' +
      '<button type="button" class="btn btn--accent btn--lg btn--grow" data-add><span data-add-label>Köp nu</span></button></div>';

    html += '<div data-trust></div>';
    html += '</div></div>';

    root.innerHTML = html;
    var trustTpl = section.querySelector('[data-designer-trust]');
    var trustSlot = root.querySelector('[data-trust]');
    if (trustTpl && trustSlot) trustSlot.appendChild(trustTpl.content.cloneNode(true));

    bind(tab);
    refresh(tab);
  }

  function previewMarkup(tab) {
    if (tab === 'social') {
      return '<div class="designer__social" data-mirror-target>' +
        '<img class="designer__icon" alt="" data-preview-icon>' +
        '<p class="designer__text designer__text--social" data-preview-text></p></div>';
    }
    if (tab === 'onlyfans') {
      return '<div class="designer__of" data-of-inner>' +
        '<img class="designer__of-icon" alt="" data-preview-icon>' +
        '<p class="designer__text designer__text--of" data-preview-text></p></div>';
    }
    return '<p class="designer__text" data-preview-text data-mirror-target></p>';
  }

  function bind(tab) {
    var s = tabState(tab);
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    q('[data-input-text]').addEventListener('input', function (e) { s.text = e.target.value; refresh(tab); });
    q('[data-font]').addEventListener('change', function (e) { s.font = e.target.value; refresh(tab); });
    qa('[data-color]').forEach(function (r) { r.addEventListener('change', function () { s.color = r.value; refresh(tab); }); });
    qa('[data-platform]').forEach(function (r) {
      r.addEventListener('change', function () {
        s.platform = config.platforms.filter(function (p) { return p.id === r.value; })[0] || config.platforms[0];
        refresh(tab);
      });
    });
    qa('[data-of-variant]').forEach(function (r) {
      r.addEventListener('change', function () {
        s.ofVariant = config.onlyfans.filter(function (v) { return v.id === r.value; })[0] || config.onlyfans[0];
        refresh(tab);
      });
    });
    qa('[data-size]').forEach(function (el) {
      el.addEventListener('change', function () { s.size = el.value; refresh(tab); });
    });
    var mirror = q('[data-mirror]');
    if (mirror) mirror.addEventListener('change', function () { s.mirrored = mirror.checked; refresh(tab); });
    var qty = q('[data-qty]');
    T.initQtySteppers(root);
    qa('[data-qty-step]').forEach(function (b) { b.addEventListener('click', function () { s.qty = parseInt(qty.value, 10) || 1; }); });
    qty.addEventListener('change', function () { s.qty = Math.max(1, Math.min(99, parseInt(qty.value, 10) || 1)); qty.value = s.qty; });
    q('[data-add]').addEventListener('click', function (e) { addToCart(tab, e.currentTarget); });

    if (tab === 'onlyfans' && 'ResizeObserver' in window) {
      new ResizeObserver(function () { fitOnlyFans(); }).observe(q('[data-preview]'));
    }
  }

  function refresh(tab) {
    var s = tabState(tab);
    var def = TABS[tab];
    var info = infos[def.product];
    var font = fontInfo(tab);
    var textEl = root.querySelector('[data-preview-text]');
    var icon = root.querySelector('[data-preview-icon]');
    var shown = s.text || def.previewFallback;
    textEl.textContent = shown;
    textEl.style.fontFamily = font.family;

    if (tab === 'onlyfans') {
      textEl.style.color = s.ofVariant.hex;
      icon.src = s.ofVariant.image;
      icon.alt = s.ofVariant.name;
      var label = root.querySelector('[data-color-name]');
      if (label) label.textContent = s.ofVariant.name;
      fitOnlyFans();
    } else {
      var hex = COLOR_HEX[s.color] || '#000000';
      textEl.style.color = hex;
      textEl.classList.toggle('is-white', hex.toUpperCase() === '#FFFFFF');
      var colorName = root.querySelector('[data-color-name]');
      if (colorName) colorName.textContent = s.color;
      if (icon) {
        icon.src = s.platform.icon;
        icon.alt = s.platform.name;
        icon.style.filter = COLOR_FILTER[s.color] || 'none';
      }
      if (tab === 'social') {
        textEl.classList.toggle('is-large', s.font === '3.0');
        textEl.style.transform = s.font === '4.0' ? 'translateY(-2px)' : '';
      }
      var mt = root.querySelector('[data-mirror-target]');
      if (mt) mt.style.transform = s.mirrored ? 'scaleX(-1)' : '';
    }

    // Prices
    var variant = currentVariant(tab);
    var priceEl = root.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = variant ? T.formatMoney(variant.price) : '—';
    var btn = root.querySelector('[data-add]');
    var available = !!(variant && variant.available);
    btn.disabled = !available;
    root.querySelector('[data-add-label]').textContent = available ? 'Köp nu' : 'Slut i lager';

    if (info.sizeIdx > -1) {
      var product = products[def.product];
      product.optionValues[info.sizeIdx].forEach(function (size) {
        var v = currentVariant(tab, { size: size });
        var label = v ? size + ' · ' + T.formatMoney(v.price) : size;
        root.querySelectorAll('[data-size]').forEach(function (el) {
          if (el.tagName === 'SELECT') {
            Array.prototype.forEach.call(el.options, function (o) { if (o.value === size) o.textContent = label; });
          } else if (el.value === size) {
            el.nextElementSibling.textContent = label;
          }
        });
      });
    }
  }

  function fitOnlyFans() {
    var box = root.querySelector('[data-preview]');
    var inner = root.querySelector('[data-of-inner]');
    if (!box || !inner) return;
    var s = tabState('onlyfans');
    inner.style.transform = 'none';
    var available = box.clientWidth - 48;
    var natural = inner.scrollWidth;
    var scale = natural > 0 ? Math.min(1, available / natural) : 1;
    inner.style.transform = 'scale(' + scale + ')' + (s.mirrored ? ' scaleX(-1)' : '');
  }

  /* ---------------- Add to cart ---------------- */
  function addToCart(tab, btn) {
    var s = tabState(tab);
    var def = TABS[tab];
    var info = infos[def.product];
    var product = products[def.product];
    var text = s.text.trim();
    if (!text) {
      T.toast(def.empty, 'error');
      var input = root.querySelector('[data-input-text]');
      if (input) input.focus();
      return;
    }
    var variant = currentVariant(tab);
    if (!variant || !variant.available) { T.toast('Varianten är inte tillgänglig', 'error'); return; }

    var font = fontInfo(tab);
    var fontLabel = s.font + ' — ' + font.name;
    var props = [];
    if (tab === 'text') {
      props.push(['Text', text], ['Typsnitt', fontLabel]);
      if (info.colorIdx > -1 && isFakeColor(info, s.color)) props.push([product.optionNames[info.colorIdx], s.color]);
    } else if (tab === 'social') {
      props.push(['Plattform', s.platform.name], ['Användarnamn', text], ['Typsnitt', fontLabel]);
      if (info.colorIdx > -1 && isFakeColor(info, s.color)) props.push([product.optionNames[info.colorIdx], s.color]);
    } else {
      props.push(['Plattform', 'OnlyFans'], ['Variant', s.ofVariant.name + ' (' + s.ofVariant.hex + ')'], ['Text', text], ['Typsnitt', fontLabel]);
    }
    if (s.mirrored) props.push(['Spegelvänd', 'Ja']);

    var build = function (file) {
      var fd = new FormData();
      fd.append('id', variant.id);
      fd.append('quantity', s.qty || 1);
      props.forEach(function (p) { fd.append('properties[' + p[0] + ']', p[1]); });
      if (file) fd.append('properties[_Vektorfil (SVG)]', file, file.name);
      return fd;
    };

    btn.disabled = true;
    btn.classList.add('is-loading');
    var previewText = root.querySelector('[data-preview-text]');
    var spec = {
      text: text,
      fontUrl: font.url,
      colorHex: tab === 'onlyfans' ? s.ofVariant.hex : (COLOR_HEX[s.color] || '#000000'),
      mirrored: s.mirrored
    };
    var measured = measurePreviewLines(previewText);
    if (measured) { spec.lines = measured.lines; spec.lineHeightRatio = measured.lineHeightRatio; }
    if (tab === 'social') spec.icon = { src: s.platform.icon, filter: COLOR_FILTER[s.color], heightRatio: 1, gapRatio: 0.25 };
    if (tab === 'onlyfans') { spec.skewDeg = -14; spec.icon = { src: s.ofVariant.image, heightRatio: 1.25, gapRatio: -0.05 }; }

    var label = tab === 'social' ? s.platform.name + '-' + text : tab === 'onlyfans' ? 'onlyfans-' + text : text;

    buildSvgFile(spec, label)
      .catch(function (e) { console.error('SVG kunde inte skapas', e); return null; })
      .then(function (file) {
        return T.Cart.addFormData(build(file), btn).catch(function (err) {
          if (!file) throw err;
          // The upload was rejected – add the design without the file instead.
          console.warn('Vektorfil kunde inte bifogas, lägger till utan fil.', err);
          return T.Cart.addFormData(build(null), btn);
        });
      })
      .catch(function (err) { T.toast(err.message || 'Något gick fel', 'error'); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  }

  /* ---------------- SVG vector generation ---------------- */
  var FONT_SIZE = 200;
  var PADDING = 20;
  var scriptCache = {};
  var fontCache = {};

  function loadScript(src) {
    if (!scriptCache[src]) {
      scriptCache[src] = new Promise(function (resolve, reject) {
        var el = document.createElement('script');
        el.src = src;
        el.onload = resolve;
        el.onerror = function () { reject(new Error('Kunde inte ladda ' + src)); };
        document.head.appendChild(el);
      });
    }
    return scriptCache[src];
  }

  function loadFont(url) {
    if (!fontCache[url]) {
      fontCache[url] = fetch(url)
        .then(function (r) { if (!r.ok) throw new Error('Font saknas: ' + url); return r.arrayBuffer(); })
        .then(function (buf) { return window.opentype.parse(buf); });
    }
    return fontCache[url];
  }

  function toDataUrl(url) {
    return fetch(url).then(function (r) { return r.blob(); }).then(function (blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }).then(function (href) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () { resolve({ href: href, width: img.naturalWidth || 1, height: img.naturalHeight || 1 }); };
        img.onerror = function () { resolve({ href: href, width: 1, height: 1 }); };
        img.src = href;
      });
    });
  }

  function n(v) { return (Math.round(v * 1000) / 1000).toString(); }

  function commandsToPathData(commands) {
    return commands.map(function (c) {
      switch (c.type) {
        case 'M': return 'M' + n(c.x) + ' ' + n(c.y);
        case 'L': return 'L' + n(c.x) + ' ' + n(c.y);
        case 'C': return 'C' + n(c.x1) + ' ' + n(c.y1) + ' ' + n(c.x2) + ' ' + n(c.y2) + ' ' + n(c.x) + ' ' + n(c.y);
        case 'Q': return 'Q' + n(c.x1) + ' ' + n(c.y1) + ' ' + n(c.x) + ' ' + n(c.y);
        case 'Z': return 'Z';
        default: return '';
      }
    }).join(' ');
  }

  /** Reads the exact rendered lines from the live preview so the SVG matches 1:1. */
  function measurePreviewLines(el) {
    try {
      if (!el) return null;
      var node = el.firstChild;
      if (!node || node.nodeType !== 3) return null;
      var content = node.textContent || '';
      if (!content) return null;
      var style = window.getComputedStyle(el);
      var fontSize = parseFloat(style.fontSize) || 16;
      var range = document.createRange();
      var lines = [], current = '', currentTop = null;
      var lineHeight = parseFloat(style.lineHeight) || fontSize;
      for (var i = 0; i < content.length; i++) {
        range.setStart(node, i);
        range.setEnd(node, i + 1);
        var top = Math.round(range.getBoundingClientRect().top * 2) / 2;
        if (currentTop === null) currentTop = top;
        if (Math.abs(top - currentTop) > 1) { lines.push(current); current = ''; currentTop = top; }
        current += content[i];
      }
      if (current) lines.push(current);
      if (lines.length > 1) {
        range.setStart(node, 0); range.setEnd(node, 1);
        var first = range.getBoundingClientRect().top;
        var idx = lines[0].length;
        range.setStart(node, idx); range.setEnd(node, idx + 1);
        var delta = Math.abs(range.getBoundingClientRect().top - first);
        if (delta > 0) lineHeight = delta;
      }
      return { lines: lines.map(function (l) { return l.replace(/\s+$/, ''); }), lineHeightRatio: lineHeight / fontSize };
    } catch (e) { return null; }
  }

  var paperReady = false;
  function ensurePaper() {
    if (!paperReady) { window.paper.setup(new window.paper.Size(1000, 1000)); paperReady = true; }
  }

  function closePathData(d) {
    try {
      ensurePaper();
      var cp = new window.paper.CompoundPath({ pathData: d, insert: false });
      var children = cp.children && cp.children.length ? cp.children : [cp];
      children.forEach(function (c) { if (c && typeof c.closed === 'boolean') c.closed = true; });
      var out = cp.pathData;
      return out && out.trim() ? out : d;
    } catch (e) { return d; }
  }

  /** Merges overlapping glyph outlines into single closed shapes (plotter/cutter friendly). */
  function unitePathData(pathDatas) {
    var inputs = pathDatas.filter(function (d) { return d && d.trim().length > 0; }).map(closePathData);
    if (inputs.length <= 1) return inputs;
    try {
      ensurePaper();
      var merged = [];
      inputs.forEach(function (d) {
        var cur = new window.paper.CompoundPath({ pathData: d, insert: false });
        var combined = true;
        while (combined) {
          combined = false;
          for (var i = merged.length - 1; i >= 0; i--) {
            if (!merged[i].bounds.intersects(cur.bounds)) continue;
            var united = merged[i].unite(cur, { insert: false });
            var overlaps = Math.abs(united.area) < Math.abs(merged[i].area) + Math.abs(cur.area) - 0.5;
            if (!overlaps) continue;
            cur = united;
            merged.splice(i, 1);
            combined = true;
          }
        }
        merged.push(cur);
      });
      var out = merged.map(function (m) { return m.pathData; }).filter(Boolean).map(closePathData);
      return out.length ? out : inputs;
    } catch (e) {
      console.error('Path union failed, using raw glyphs', e);
      return inputs;
    }
  }

  function toPaths(pathDatas, colorHex) {
    return unitePathData(pathDatas).map(function (d) { return '<path d="' + d + '" fill="' + colorHex + '"/>'; }).join('');
  }

  function buildDecalSvg(spec) {
    return loadFont(spec.fontUrl).then(function (font) {
      var lines = (spec.lines && spec.lines.length ? spec.lines : spec.text.split('\n'))
        .filter(function (l, i, arr) { return l.length > 0 || arr.length === 1; });
      var lineStep = FONT_SIZE * (spec.lineHeightRatio || 1.1);

      var measured = lines.map(function (line) {
        var b = font.getPath(line || ' ', 0, 0, FONT_SIZE).getBoundingBox();
        return { line: line, x1: b.x1, y1: b.y1, y2: b.y2, width: Math.max(1, b.x2 - b.x1) };
      });
      var textW = Math.max.apply(null, [1].concat(measured.map(function (m) { return m.width; })));
      var topY = measured[0].y1;
      var bottomY = measured[measured.length - 1].y2 + lineStep * (measured.length - 1);
      var textH = Math.max(1, bottomY - topY);

      var glyphData = [];
      measured.forEach(function (m, i) {
        var dx = (textW - m.width) / 2 - m.x1;
        var dy = -topY + i * lineStep;
        font.getPaths(m.line || ' ', dx, dy, FONT_SIZE).forEach(function (p) {
          var d = commandsToPathData(p.commands);
          if (d.trim()) glyphData.push(d);
        });
      });
      var textMarkup = toPaths(glyphData, spec.colorHex);

      var skewedW = textW;
      if (spec.skewDeg) {
        var shift = Math.abs(Math.tan((spec.skewDeg * Math.PI) / 180)) * textH;
        skewedW = textW + shift;
        var sdx = spec.skewDeg < 0 ? shift : 0;
        textMarkup = '<g transform="translate(' + sdx.toFixed(2) + ' 0) skewX(' + spec.skewDeg + ')">' + textMarkup + '</g>';
      }

      var iconPromise = spec.icon ? toDataUrl(spec.icon.src) : Promise.resolve(null);
      return iconPromise.then(function (icon) {
        var iconMarkup = '', offsetX = 0;
        if (icon) {
          var iconH = textH * (spec.icon.heightRatio || 1);
          var iconW = (icon.width / icon.height) * iconH;
          var gap = textH * (spec.icon.gapRatio == null ? 0.2 : spec.icon.gapRatio);
          var filter = spec.icon.filter && spec.icon.filter !== 'none' ? ' style="filter:' + spec.icon.filter + '"' : '';
          iconMarkup = '<image href="' + icon.href + '" x="0" y="' + ((textH - iconH) / 2).toFixed(2) + '" width="' + iconW.toFixed(2) + '" height="' + iconH.toFixed(2) + '"' + filter + '/>';
          offsetX = iconW + gap;
        }
        var contentW = offsetX + skewedW;
        var totalW = contentW + PADDING * 2;
        var totalH = textH + PADDING * 2;
        var body = iconMarkup + '<g transform="translate(' + offsetX.toFixed(2) + ' 0)">' + textMarkup + '</g>';
        var wrapped = spec.mirrored ? '<g transform="translate(' + contentW.toFixed(2) + ' 0) scale(-1 1)">' + body + '</g>' : body;
        return '<?xml version="1.0" encoding="UTF-8"?>\n' +
          '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + totalW.toFixed(2) + '" height="' + totalH.toFixed(2) + '" viewBox="0 0 ' + totalW.toFixed(2) + ' ' + totalH.toFixed(2) + '">\n' +
          '  <g transform="translate(' + PADDING + ' ' + PADDING + ')">' + wrapped + '</g>\n</svg>';
      });
    });
  }

  function slugify(value) {
    return String(value).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) || 'dekal';
  }

  function buildSvgFile(spec, label) {
    return Promise.all([loadScript(config.vendor.opentype), loadScript(config.vendor.paper)])
      .then(function () { return buildDecalSvg(spec); })
      .then(function (svg) {
        var name = slugify(label) + '-' + Date.now() + '.svg';
        return new File([svg], name, { type: 'image/svg+xml' });
      });
  }

  /* ---------------- Tabs ---------------- */
  var tabButtons = Array.prototype.slice.call(section.querySelectorAll('[data-tab]'));
  function selectTab(tab) {
    if (!TABS[tab] || (TABS[tab].product === 'social' && !products.social)) tab = 'text';
    tabButtons.forEach(function (b) {
      var active = b.getAttribute('data-tab') === tab;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', String(active));
    });
    renderPanel(tab);
  }
  tabButtons.forEach(function (b) {
    b.addEventListener('click', function () {
      var tab = b.getAttribute('data-tab');
      selectTab(tab);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('typ', tab);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  var initial = new URL(window.location.href).searchParams.get('typ') || 'text';
  selectTab(initial);
})();
